import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';

import { AppContextProvider, Env } from '@contexts/AppContext';
import useEventTracking from '@hooks/useEventTracking';
import { Page } from '@tracking';
import { User } from '@utils/backend-api/currentUser';

import BlueprintContent from './BlueprintContent';
import { Section } from './types';

const queryClient = new QueryClient();

interface BlueprintProps {
  initialCurrentUser?: User;
  isGdprRequired: boolean;
  env: Env;
  sections: Section[];
}

const Blueprint = ({ initialCurrentUser, isGdprRequired, env, sections }: BlueprintProps) => {
  const { Track } = useEventTracking({ page: Page.Blueprint });

  return (
    <Track>
      <AppContextProvider
        initialCurrentUser={initialCurrentUser}
        isGdprRequired={isGdprRequired}
        env={env}
      >
        <QueryClientProvider client={queryClient}>
          <BlueprintContent sections={sections} />
        </QueryClientProvider>
      </AppContextProvider>
    </Track>
  );
};

export default Blueprint;
